import { StyleSheet } from 'react-native';

import { SEPARATOR_STROKE,SIZES, PALETTE  } from '../../../constants';

export default StyleSheet.create({
  container: {
    
    alignSelf: 'stretch'  ,
    backgroundColor: '#fff4d6',


    paddingVertical: 20,
    paddingHorizontal: 10
    
  },

  rotate180:{
    transform: [{ rotate: '180deg'}],
  },

  rowBorder: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
 
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },

  headerContent:{
    paddingRight:50

  },


  rowContent:{
    paddingVertical: 10,
    paddingRight: 5

  },



  arrowCol: {
    width: 20,
    position: 'absolute',
    top: 25,
    right: 0
  }


});




export const arrowSVGStyles = {
  height: 7,
  width: 14,
  thickness: 1,
  color: PALETTE.secondaryText,
};



export const arrowSVGStylesUp = {
  height: 7,
  width: 14,
  thickness: 1,
  color: PALETTE.secondaryText,
};
